(function () {
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var iconMenu = document.querySelector('[data-icon-menu]');
  var iconClose = document.querySelector('[data-icon-close]');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var isOpen = !menu.classList.contains('hidden');
      menu.classList.toggle('hidden', isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      if (iconMenu && iconClose) {
        iconMenu.classList.toggle('hidden', !isOpen);
        iconClose.classList.toggle('hidden', isOpen);
      }
    });
  }

  if (header) {
    var onScroll = function () {
      header.classList.toggle('shadow-[0_4px_30px_rgba(204,171,102,0.2)]', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Cart badge/aria-label sync is fully owned by window.Velo.updateCartUI
  // (assets/checkout-selected-variant.js), called from cart-drawer.js and
  // the shared checkout action - no separate listener needed here.

  var navItems = document.querySelectorAll('[data-nav-item]');
  var isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var closeAllNavItems = function () {
    navItems.forEach(function (item) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('[data-nav-dropdown-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  if (navItems.length && !isFinePointer) {
    navItems.forEach(function (item) {
      var trigger = item.querySelector('[data-nav-dropdown-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function (event) {
        var isOpen = item.classList.contains('is-open');
        if (!isOpen) {
          event.preventDefault();
          closeAllNavItems();
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (event) {
      navItems.forEach(function (item) {
        if (!item.contains(event.target)) {
          item.classList.remove('is-open');
          var trigger = item.querySelector('[data-nav-dropdown-trigger]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  if (navItems.length) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllNavItems();
      }
    });
  }
})();
